var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"err-msg text-red-2 l-0"},[_c('i',{staticClass:"fas fa-exclamation-circle mr-xs"}),_c('span',{domProps:{"textContent":_vm._s(_vm.msg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }